import { useQuery } from "@tanstack/react-query";
import { Alert, Badge, Card, CardBody, EmptyState, LoadingState } from "@agentnative/ui";
import { apiErrorMessage } from "../lib/api/client";
import { listApps } from "../lib/api/catalog";

// Minimal catalog browse page -- proves the catalog renders. Deep
// marketplace UX (install flows, filtering, search) is explicitly out of
// scope for this task.
export function MarketplaceRoute() {
  const appsQuery = useQuery({
    queryKey: ["apps"],
    queryFn: () => listApps({ limit: 100, offset: 0 }),
  });

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Marketplace</h1>

      {appsQuery.isLoading ? (
        <LoadingState message="Loading catalog..." />
      ) : appsQuery.isError ? (
        <Alert variant="danger" title="Failed to load catalog">
          {apiErrorMessage(appsQuery.error)}
        </Alert>
      ) : (appsQuery.data?.apps.length ?? 0) === 0 ? (
        <EmptyState title="No apps in the catalog" />
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {appsQuery.data!.apps.map((app) => (
            <Card key={app.id} padding="lg">
              <CardBody>
                <div className="flex items-start justify-between">
                  <h2 className="font-medium">{app.name}</h2>
                  {app.category && <Badge variant="default">{app.category}</Badge>}
                </div>
                <p className="mt-1 text-sm text-[var(--color-neutral-600)]">{app.description}</p>
                <p className="mt-2 text-xs text-[var(--color-neutral-500)]">
                  Slug: <span className="font-mono">{app.slug}</span>
                </p>
              </CardBody>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
